import { Trans } from 'react-i18next'
import { Link } from 'settle-ui/components/Link/Link'
import { RouterPage } from 'lib/navigation/consts'
import { useAppliedPromoCodeContext } from 'routes/hooks/useAppliedPromoCodeContext/useAppliedPromoCodeContext'
import { useOnboardingLayoutContext } from '../../../../hooks/useOnboardingLayoutContext/useOnboardingLayoutContext'
import * as $ from './OnboardingBanners.styled'
import { ReferralTypeEnum } from 'gql/types'

export const OnboardingBanners = () => {
  const { referrer } = useOnboardingLayoutContext()
  const { promoCode } = useAppliedPromoCodeContext()
  const { affiliateName = 'N/A', type } = referrer ?? {}
  const banners = []

  if (type === ReferralTypeEnum.AFFILIATE) {
    if (promoCode) {
      const { termsLink, amountOff } = promoCode
      const amountOffFormatted = amountOff?.formattedNoCents ?? 'N/A'

      banners.push(
        <$.OnboardingReferralBanner key="onboarding-referral-banner" data-testid="affiliate-referral-banner">
          <Trans
            values={{ affiliateName, amountOff: amountOffFormatted }}
            i18nKey="onboarding::affiliateReferralBanner::title"
            components={{
              termsLink: <Link variant="inherit" underline="always" href={termsLink} target="_blank" />,
            }}
          />
        </$.OnboardingReferralBanner>,
      )
    }
  } else {
    if (promoCode?.applied) {
      banners.push(<$.AppliedPromoCodeMessage key="applied-promo-code-message" type="onboarding" />)
    }
    if (referrer) {
      banners.push(
        <$.OnboardingReferralBanner key="onboarding-referral-banner" data-testid="regular-referral-banner">
          <Trans
            i18nKey="onboarding::referralsBanner::title"
            components={{
              termsLink: <Link variant="inherit" underline="always" href={RouterPage.referralTermsAndConditions} />,
            }}
          />
        </$.OnboardingReferralBanner>,
      )
    }
  }

  if (banners.length === 0) {
    return null
  }

  return <$.Root>{banners}</$.Root>
}
